import { useEffect, useState, useRef } from "react";
import "./painelsugestao.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLightbulb,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function PainelSugestao({ onRegistrar }) {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [sugestoes, setSugestoes] = useState([]);
  const [tipoRefeicao, setTipoRefeicao] = useState("");

  // ✅ REF DO CARROSSEL
  const carrosselRef = useRef(null);

  const carregarSugestoes = async () => {
    try {
      setLoading(true);
      setErro(null);

      const res = await fetch(`${API_BASE}/get-sugestoes-refeicao.php`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status !== "sucesso") {
        throw new Error(data.mensagem || "Erro ao carregar sugestões");
      }

      setMensagem(data.mensagem);
      setSugestoes(data.sugestoes || []);
      setTipoRefeicao(data.tipo_refeicao);
    } catch {
      setErro("Não foi possível carregar sugestões agora.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSugestoes();
  }, []);

  // ✅ HANDLERS DAS SETAS (SCROLL REAL)
  const scrollDireita = () => {
    if (!carrosselRef.current) return;

    carrosselRef.current.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  const scrollEsquerda = () => {
    if (!carrosselRef.current) return;

    carrosselRef.current.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  if (loading) {
    return (
      <div className="painel-sugestao loading">
        Carregando sugestões…
      </div>
    );
  }

  if (erro) {
    return (
      <div className="painel-sugestao erro">
        {erro}
      </div>
    );
  }

  return (
    <div className="painel-sugestao">
      {/* ================= HEADER ================= */}
      <div className="painel-sugestao-header">
        <h3 className="painel-sugestao-titulo">
          <FontAwesomeIcon icon={faLightbulb} className="icone-lampada" />
          {mensagem}
        </h3>

        <div className="painel-sugestao-acoes">
          {/* ✅ SETA ESQUERDA */}
          <button
            className="btn-seta"
            aria-label="Sugestões anteriores"
            onClick={scrollEsquerda}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          {/* ✅ SETA DIREITA */}
          <button
            className="btn-seta"
            aria-label="Próximas sugestões"
            onClick={scrollDireita}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>

          {/* 🔄 RECARREGAR */}
          <button
            className="btn-reload"
            onClick={carregarSugestoes}
            title="Ver outras sugestões"
          >
            ↻
          </button>
        </div>
      </div>

      {/* ================= CARROSSEL ================= */}
      <div
        className="painel-sugestao-carrossel"
        ref={carrosselRef}
      >
        {sugestoes.map((item) => (
          <div className="sugestao-card" key={item.id}>
            <h4 className="sugestao-titulo">{item.titulo}</h4>

            <p className="sugestao-itens">
              {item.itens}
            </p>

            {/* 🔥 CALORIAS EM DESTAQUE (SEM MACROS) */}
            <div className="sugestao-calorias">
              <strong>{item.calorias}</strong>
              <span>kcal</span>
            </div>

            <button
              className="btn-registrar"
              onClick={() =>
                onRegistrar({
                  tipo_refeicao: tipoRefeicao,
                  texto: item.itens,
                  calorias: item.calorias,
                  macros: item.macros, // mantido para o modal
                  origem: "sugestao",
                  cardapio_id: item.id,
                })
              }
            >
              Registrar essa refeição
            </button>
          </div>
        ))}
      </div>

      {/* ================= FOOTER ================= */}
      <div className="painel-sugestao-footer">
        <a
          href={`/cardapios?ref=${tipoRefeicao}`}
          className="ver-mais"
        >
          Ver mais sugestões
        </a>
      </div>
    </div>
  );
}
